import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/**
 * Dialog data passed into the ActivateSuspendDialogComponent.
 */
export interface ActivateSuspendDialogData {
  action: 'activate' | 'suspend';
  username?: string;
}

/**
 * Dialog component used to confirm user activation or suspension.
 */
@Component({
  selector: 'app-activate-suspend-dialog',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatButtonModule],
  templateUrl: './activate-suspend-dialog.component.html',
  styleUrl: './activate-suspend-dialog.component.scss',
})
export class ActivateSuspendDialogComponent {
  /**
   * Creates an instance of ActivateSuspendDialogComponent.
   * @param data - Dialog input data with action type and optional username.
   * @param dialogRef - Reference to the current open dialog.
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ActivateSuspendDialogData,
    public dialogRef: MatDialogRef<ActivateSuspendDialogComponent>
  ) { }

  /**
   * Closes the dialog and confirms the action.
   */
  onConfirm(): void {
    this.dialogRef.close('confirm');
  }

  /**
   * Closes the dialog and cancels the action.
   */
  onCancel(): void {
    this.dialogRef.close('cancel');
  }
}
